import { default as MRoyal } from "./m-royal.json";
import { default as KeepControl } from "./keep-control.json";
import { default as SynthwaveIsDead } from "./synthwave-is-dead.json";

const releases = [
  MRoyal,
  KeepControl,
  SynthwaveIsDead
];

export default releases;